export default {
    data() {
        return {
            tableGBoptions: {
                options: { editar: 'Editar Asesor', inactivar: 'Inactivar Asesor' },
                modals: []
            },

            tableGBSearch: ['datos_asesor/name'],

            tableGBItems: [{
                    thead: { th: 'Documento', sort: null, sortTable: 'datos_asesor/documento' },
                    tbody: { td: ['datos_asesor/documento'], }
                },
                {
                    thead: { th: 'Razón', sort: null, sortTable: 'datos_asesor/name' },
                    tbody: { td: ['datos_asesor/name'], }
                },
                {
                    thead: { th: 'Comisión mensual', },
                    tbody: { td: ['datos_asesor/comision'], }
                },
                {
                    thead: { th: 'Teléfonos', },
                    tbody: { td: ['datos_asesor/telefonos'], }
                },
                {
                    thead: { th: 'Email', },
                    tbody: { td: ['datos_asesor/email'], }
                },
            ]
        }
    },
}